// extracted by mini-css-extract-plugin
export default {"selectorFooter":"SelectorFooter-module__selectorFooter___VELmP"};